module.exports = __webpack_public_path__ + "img/voellerei.d81eeb74.png";